export default "__VITE_ASSET__Bq5_Ntjr__"